import api from '.';

async function request(path, { body, signal } = {}) {
    try {
        const response =
            body === undefined ? await api.get(`/caixa${path}`, { signal }) : await api.post(`/caixa${path}`, body, { signal });
        if (!response?.data || !Object.prototype.hasOwnProperty.call(response.data, 'data')) {
            throw new Error('Resposta inválida da consulta SIS. Atualize o estado antes de repetir uma ação.');
        }
        return response.data.data;
    } catch (error) {
        const dados = error.response?.data;
        throw Object.assign(new Error(dados?.message || dados?.codigo || error.message || 'Falha na operação do caixa.'), {
            codigo: dados?.codigo,
            status: error.response?.status,
        });
    }
}
export const consultarCaixaSis = (uuid, signal) => request(`/sis/consulta/${encodeURIComponent(uuid)}`, { signal });
export const conferirCaixaSis = (uuid) => request('/sis/conferir', { body: { caixaUuid: uuid } });
export const consolidarCaixaSis = (uuid) => request('/sis/consolidar', { body: { caixaUuid: uuid } });
export async function identificarCaixasSis(uuids) {
    const unicos = [...new Set(uuids)];
    const rows = [];
    for (let i = 0; i < unicos.length; i += 100) {
        const data = await request('/sis/identificar', { body: { caixaUuids: unicos.slice(i, i + 100) } });
        if (!Array.isArray(data)) throw new Error('Identificação de caixas inválida.');
        rows.push(...data);
    }
    const mapa = new Map(rows.map((r) => [r.caixaUuid, r.sis]));
    if (unicos.some((u) => typeof mapa.get(u) !== 'boolean')) throw new Error('Não foi possível identificar todos os caixas.');
    return mapa;
}
